<template>
  <div class="feed-back">
    <navbar leftText showHome title="意见反馈"></navbar>
    <div class="feed-back-wrapper">
      <div class="writing-area">
        <field
          autosize
          maxlength="100"
          placeholder="我们重视您的反馈，请您留下宝贵建议； 谢谢"
          rows="6"
          show-word-limit
          type="textarea"
          v-model="feedbackDesc"
        />
      </div>
      <div class="submit">
        <button @click="submit">提交</button>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from '../components/NavBar'
import { Field } from 'vant'
export default {
  name: 'feedback',
  components: {
    Navbar,
    Field
  },
  data () {
    return {
      feedbackDesc: ''
    }
  },
  methods: {
    async submit () {
      const res = await this.$axios.post('api/qu/feedback', { msg: this.feedbackDesc })
      if (res.status === 200) {
        const { code, msg } = res.data
        if (code === 0) {
          this.$toast('提交成功')
          setTimeout(() => {
            this.$router.push({ name: 'feedbackSuc' })
          }, 1500)
        } else {
          this.$toast(msg)
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.feed-back {
  .writing-area {
    margin: 0.2rem 0 0.3rem;
    padding: 0.35rem;
    background-color: #fff;
  }
  .submit {
    text-align: center;
    button {
      width: 6.8rem;
      height: 0.88rem;
      background-color: #3498db;
      color: #fff;
      font-size: @fz28;
      border-radius: 30px;
    }
  }
}
</style>
